module.exports = __webpack_public_path__ + "static/media/radiodifusionGraph.5e534e16.mp4";